import BaseForm from '../base';
import { LatLongColumnsComponent } from '../components';
export class PadlocksForm extends BaseForm {
    constructor(...args) {
        super(...args);
        this.components = [
            new LatLongColumnsComponent(),
            {
                label: 'Timezone',
                key: 'timezone',
                type: 'select-timezone',
            },
            {
                label: 'Battery',
                key: 'battery',
                type: 'textfield',
            },
            {
                label: 'Access Type',
                key: 'accessType',
                type: 'textfield',
            },
            {
                label: 'Hardware Version',
                key: 'hwVersion',
                type: 'textfield',
            },
            {
                label: 'Mac Address',
                key: 'macAddress',
                type: 'textfield',
            },
            {
                label: 'Serial',
                key: 'serial',
                type: 'textfield',
            },
            {
                label: 'API Type',
                key: 'apiType',
                type: 'textfield',
            },
        ];
    }
}
